<nav class="navbar navbar-expand-lg align-items-lg-center container-p-x" [ngClass]="currentBg()">

  <!-- Brand demo (see demo.css) -->
  <a routerLink="/" class="navbar-brand app-brand demo d-lg-none py-0 mr-4">

    <span class="app-brand-logo demo bg-primary">
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px" y="0px" width="256px" height="256px" viewBox="0 0 256 256" enable-background="new 0 0 256 256"
        xml:space="preserve">
        <path fill="#FFFFFF" d="M253.725,127.805c0,69.443-56.283,125.735-125.724,125.735c-69.438,0-125.726-56.292-125.726-125.735
     C2.275,58.38,58.563,2.09,128.001,2.09C197.439,2.09,253.725,58.38,253.725,127.805z" />
        <g>
          <path fill="none" stroke="#000000" stroke-width="14" stroke-miterlimit="10" d="M167.658,123H87.984v-21.931
       c0-14.271,3.27-25.052,9.807-32.343c6.538-7.291,16.196-10.936,28.975-10.936c6.148,0,11.742,1.018,16.779,3.054
       c5.037,2.036,9.344,4.973,12.918,8.813c3.576,3.839,6.334,8.493,8.279,13.961c1.943,5.468,2.916,11.634,2.916,18.498V123z
        M94.763,115.263h66.172v-12.797c0-5.739-0.74-10.868-2.224-15.386c-1.479-4.517-3.655-8.347-6.526-11.488
       c-2.869-3.142-6.418-5.536-10.642-7.184c-4.224-1.648-9.073-2.472-14.558-2.472c-21.483,0-32.226,11.887-32.226,35.658
       L94.763,115.263L94.763,115.263z" />
        </g>
        <g>
          <rect x="80.966" y="144.367" width="93.71" height="21.581" />
          <rect x="117.209" y="165.948" width="21.582" height="38.219" />
        </g>
      </svg>

    </span>
    <span class="app-brand-text demo font-weight-normal ml-2">D A N T</span>
  </a>

  <!-- Sidenav toggle (see demo.css) -->
  <div class="layout-sidenav-toggle navbar-nav d-lg-none align-items-lg-center mr-auto" *ngIf="sidenavToggle">
    <a class="nav-item nav-link px-0 mr-lg-4" href="javascript:void(0)" (click)="toggleSidenav()">
      <i class="ion ion-md-menu text-large align-middle"></i>
    </a>
  </div>

  <button class="navbar-toggler" type="button" (click)="isExpanded = !isExpanded">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="navbar-collapse collapse" [ngbCollapse]="!isExpanded">
    <!-- Divider -->
    <hr class="d-lg-none w-100 my-2">

    <div class="navbar-nav align-items-lg-center">
      <!-- Search -->
      <label class="nav-item navbar-text navbar-search-box p-0 active">
        <i class="ion ion-ios-search navbar-icon align-middle" *ngIf="!searching"></i>
        <div class="spinner-border spinner-border-sm text-primary" role="status" *ngIf="searching">
          <span class="sr-only">Loading...</span>
        </div>

        <span class="navbar-search-input pl-2">

          <!-- Form -->
          <form [formGroup]="form" #ngForm="ngForm" class="form-inline" novalidate>

            <!-- With template -->
            <ng-template #rt let-r="result" let-t="term">
              <div *ngIf="r.usu_status == 'I'" class="badge badge-danger">{{'status.inativo' | translate }}
              </div>
              <ngb-highlight [result]="r.usu_nome" [term]="t"></ngb-highlight>
              <div class="clearfix">
                <span class="float-left small">{{ 'perfil_de_acesso.' + r.fk_idperfisdeacesso |
                  translate}}</span>
              </div>

            </ng-template>

            <input id="typeahead-template" type="text" class="form-control navbar-text mx-2" style="width:200px"
              formControlName="search_term" id="search_term" [ngbTypeahead]="search" [resultTemplate]="rt"
              [inputFormatter]="formatter" [placement]="isRTL ? 'bottom-right' : 'bottom-left'" (click)="clear()"
              (selectItem)="selectedItem($event)" placeholder="{{ 'busca_rapida.digite_sua_pesquisa' | translate }}">
          </form>

        </span>
      </label>
    </div>

    <div class="navbar-nav align-items-lg-center ml-auto">
      <div *ngIf="!state.is404[0]" ngbDropdown [placement]="isRTL ? 'bottom-left' : 'bottom-right'"
        class="demo-navbar-notifications nav-item mr-lg-3">
        <a ngbDropdownToggle class="nav-link hide-arrow" href="javascript:void(0)">
          <i class="ion ion-md-notifications-outline navbar-icon align-middle"></i>
          <span *ngIf="offline" class="badge badge-primary badge-dot indicator"></span>
          <span class="d-lg-none align-middle">&nbsp; {{ 'dispositivo.list.notificacoes' | translate}}</span>
        </a>
        <div ngbDropdownMenu [class.dropdown-menu-right]="!isRTL" style="max-height: 400px; overflow: auto;">

          <div class="bg-primary text-center text-white font-weight-bold p-3"
            *ngIf="state.listFilterDevices && state.paging.total > 10">
            <!-- Form -->            
            <form [formGroup]="formDevice" #ngForm="ngForm" novalidate>
              <input type="text" class="form-control navbar-text" formControlName="searchTerm"
                placeholder="{{ 'busca_rapida.digite_sua_pesquisa' | translate }}"
                style="margin-left: auto; margin-right: auto;" (input)="filterDevices($event.target.value)" upperCase>
            </form>
          </div>

          <div class="list-group list-group-flush">

            <a href="javascript:void(0)" *ngFor="let obj of state.listFilterDevices" (click)="openLiberacaoManualPopup(obj)"
              class="list-group-item list-group-item-action media d-flex align-items-center">

              <div class="ui-icon ui-icon-sm ion ion-md-warning bg-warning border-0 text-body" *ngIf="!obj.dis_online">
              </div>
              <div class="media-body line-height-condenced ml-3">
                <div class="text-body">{{ obj.dis_descricao }}</div>
                <div class="text-light small mt-1">
                  <a *ngIf="obj.dis_online == true" class="badge badge-pill badge-success"
                    href="javascript:void(0)">{{'dispositivo.list.online' | translate }}</a>
                  <a *ngIf="obj.dis_online == false" class="badge badge-pill badge-danger"
                    href="javascript:void(0)">{{'dispositivo.list.offline' | translate }}</a>
                </div>
                <div class="text-light small mt-1" *ngFor="let leitor of obj.leitores_json">
                  <span class="badge badge-danger badge-dot indicator" *ngIf="!obj.dis_online"></span>
                  <a *ngIf="obj.dis_online && leitor.dis_sensorstatus" class="badge badge-outline-danger mr-2"
                    href="javascript:void(0)">{{'dispositivo.list.porta_aberta' | translate }}</a>
                  <a *ngIf="obj.dis_online && !leitor.dis_sensorstatus" class="badge badge-outline-success"
                    href="javascript:void(0)">{{'dispositivo.list.porta_fechada' | translate }}</a>
                  &nbsp;
                  {{ leitor.dis_descricao }}
                </div>

              </div>
            </a>


          </div>

        </div>
      </div>

      <div *ngIf="false" ngbDropdown [placement]="isRTL ? 'bottom-left' : 'bottom-right'"
        class="demo-navbar-messages nav-item mr-lg-3">
        <a ngbDropdownToggle class="nav-link hide-arrow" href="javascript:void(0)">
          <i class="ion ion-ios-mail navbar-icon align-middle"></i>
          <span class="badge badge-primary badge-dot indicator"></span>
          <span class="d-lg-none align-middle">&nbsp; Messages</span>
        </a>
        <div ngbDropdownMenu [class.dropdown-menu-right]="!isRTL">
          <div class="bg-primary text-center text-white font-weight-bold p-3">
            4 New Messages
          </div>
          <div class="list-group list-group-flush">
            <a href="javascript:void(0)" class="list-group-item list-group-item-action media d-flex align-items-center">
              <img src="assets/img/avatars/6-small.png" class="d-block ui-w-40 rounded-circle" alt>
              <div class="media-body ml-3">
                <div class="text-body line-height-condenced">Sit meis deleniti eu, pri vidit meliore docendi ut.</div>
                <div class="text-light small mt-1">
                  Mae Gibson &nbsp;·&nbsp; 58m ago
                </div>
              </div>
            </a>

            <a href="javascript:void(0)" class="list-group-item list-group-item-action media d-flex align-items-center">
              <img src="assets/img/avatars/4-small.png" class="d-block ui-w-40 rounded-circle" alt>
              <div class="media-body ml-3">
                <div class="text-body line-height-condenced">Mea et legere fuisset, ius amet purto luptatum te.</div>
                <div class="text-light small mt-1">
                  Kenneth Frazier &nbsp;·&nbsp; 1h ago
                </div>
              </div>
            </a>

            <a href="javascript:void(0)" class="list-group-item list-group-item-action media d-flex align-items-center">
              <img src="assets/img/avatars/5-small.png" class="d-block ui-w-40 rounded-circle" alt>
              <div class="media-body ml-3">
                <div class="text-body line-height-condenced">Sit meis deleniti eu, pri vidit meliore docendi ut.</div>
                <div class="text-light small mt-1">
                  Nelle Maxwell &nbsp;·&nbsp; 2h ago
                </div>
              </div>
            </a>

            <a href="javascript:void(0)" class="list-group-item list-group-item-action media d-flex align-items-center">
              <img src="assets/img/avatars/11-small.png" class="d-block ui-w-40 rounded-circle" alt>
              <div class="media-body ml-3">
                <div class="text-body line-height-condenced">Lorem ipsum dolor sit amet, vis erat denique in, dicunt
                  prodesset te vix.</div>
                <div class="text-light small mt-1">
                  Belle Ross &nbsp;·&nbsp; 5h ago
                </div>
              </div>
            </a>
          </div>

          <a href="javascript:void(0)" class="d-block text-center text-light small p-2 my-1">Show all messages</a>
        </div>
      </div>


      <!-- Divider -->
      <div class="nav-item d-none d-lg-block text-big font-weight-light line-height-1 opacity-25 mr-3 ml-1">|</div>

      <div ngbDropdown [placement]="isRTL ? 'bottom-left' : 'bottom-right'" class="demo-navbar-user nav-item">
        <a ngbDropdownToggle class="nav-link" href="javascript:void(0)">
          <span class="d-inline-flex flex-lg-row-reverse align-items-center align-middle">
            <i *ngIf="!img" class="ion ion-md-person d-block"></i>
            <img *ngIf="img" [src]="img" alt class="d-block ui-wh-30 rounded-circle" (error)="img = null">
            <span class="px-1 mr-lg-2 ml-2 ml-lg-0">{{ getNomeUsuario | titlecase }}</span>
          </span>
        </a>
        <div ngbDropdownMenu [class.dropdown-menu-right]="!isRTL">
          <a href="javascript:void(0)" (click)="openNewPasswordPopup()" class="dropdown-item"><i
              class="ion ion-ios-lock text-lightest"></i> &nbsp;
            {{ 'conta.edit.alterar_senha' | translate }}</a>
          <a *ngIf="false" href="javascript:void(0)" class="dropdown-item"><i
              class="ion ion-ios-mail text-lightest"></i> &nbsp;
            Messages</a>
          <a href="javascript:void(0)" (click)="openAccount()" class="dropdown-item"><i
              class="ion ion-md-settings text-lightest"></i> &nbsp;
            {{ 'conta.edit.configuracoes' | translate }}</a>

          <a href="https://dant.com.br/contato" target="_blank" class="dropdown-item"><i
              class="ion ion-ios-help-buoy text-lightest"></i> &nbsp;
            {{ 'conta.edit.suporte' | translate }}</a>

          <div class="dropdown-divider"></div>
          <a href="javascript:void(0)" (click)="logout()" class="dropdown-item"><i
              class="ion ion-ios-log-out text-danger"></i> &nbsp; {{ 'menu.logout' | translate }}</a>
        </div>
      </div>
    </div>
  </div>
</nav>